import { Alert, Cross, Image, Modal, Text } from '@cashfree-intl/coherent';
import styled from 'styled-components';
import { CUSTOM_COLORS } from 'constants/colors';

export const StyledConfirmWebsiteModal = styled(Modal)`
  .content {
    padding: 3.75rem 2.5rem 2.5rem 2.5rem !important;
    display: flex !important;
    align-items: center;
    flex-direction: column;
  }

  button {
    width: 10rem;
    margin-top: 1rem;
  }
  .ui.input {
    margin-bottom: 0 !important;
    width: 25rem !important;
    input {
      max-width: 25rem !important;
    }
  }
  @media only screen and (max-width: 767px) {
    // For overriding important style on img.ui.image need a selector of higher specificity
    img.ui.image.inactive-website {
      padding-bottom: 0px !important;
      margin-bottom: 1.5rem !important;
    }
  }
`;

export const StyledImage = styled(Image).attrs({
  className: 'inactive-website',
})`
  border-radius: 0.75rem;
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
`;

export const StyledTitle = styled(Text)`
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 1.5rem;
  text-align: center !important;
`;

export const StyledWebsiteText = styled(Text)`
  text-align: center;
  background-color: ${({ theme }) => theme.COLORS.F7DFDF};
  color: ${CUSTOM_COLORS.F77171};
  padding: 0.125rem 0.75rem;
  border-radius: 1.25rem;
  margin-bottom: 0.5rem;
`;

export const StyledCross = styled(Cross)`
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
  z-index: 1;
`;

export const StyledAlert = styled(Alert)`
  display: flex;
  align-items: flex-start;
  .inline {
    display: inline;
  }
  .highlighted {
    font-family: ${({ theme }) => theme.FONTS.bold};
  }
  margin-bottom: 1rem;
`;
